// AUTO-GENERATED by scripts/build-content.js — do not edit.
// Edit content/ instead, then run: npm run content

export interface Localized {
  tr: string;
  en: string;
}

export interface LocalizedList {
  tr: string[];
  en: string[];
}

/** One photograph in every generated width, ready for an <img> tag. */
export interface Picture {
  src: string;
  srcSet: string;
}

export interface Project {
  slug: string;
  order: number;
  showInSlider: boolean;
  title: Localized;
  year: string;
  location: string;
  area: string;
  workType: Localized;
  description: Localized;
  cover: Picture;
  images: Picture[];
}

export interface Social {
  name: string;
  url: string;
}

export interface Site {
  companyName: string;
  /** Canonical origin, used to build sitemap.xml and robots.txt. */
  siteUrl: string;
  /** Short list of what the studio does, shown right below the hero. */
  services: LocalizedList;
  about: { title: Localized; body: Localized };
  contact: {
    email: string;
    phoneText: string;
    phoneNumber: string;
    /** Shown in the footer. Empty means the line is omitted. */
    address: string;
    /** Google Maps link for the address. Empty means it renders as plain text. */
    mapsUrl: string;
  };
  socials: Social[];
}

export const site: Site = {
  "companyName": "BDÇ Mimarlık",
  "siteUrl": "https://bdcmimarlik.com",
  "services": {
    "tr": [
      "3D Görselleştirme",
      "Mimari ve İç Mimari Tasarım & Tadilat",
      "Ruhsat Projesi",
      "Restorasyon"
    ],
    "en": [
      "3D Visualization",
      "Architectural & Interior Design, Renovation",
      "Building Permit Drawings",
      "Restoration"
    ]
  },
  "about": {
    "title": {
      "tr": "Hakkımızda",
      "en": "About Us"
    },
    "body": {
      "tr": "2021 yılında mimarlık fakültesini derece ile bitiren mimar olan Büşra DİNDAR ÇÖLLÜ 4 sene aktif olarak sektörde yer alan ofislerde çalıştığı süreç boyunca kendi işlerini tamamlamış ve deneyimlerine katkı sağlamıştır. Bu sürecin sonucunda da 2025 yılında BDÇ Mimarlık şirketini kurarak bilgi ve deneyimlerini bu ofis çatısı altında birleştirmiştir.\n\nBDÇ Mimarlık bünyesinde belediye ruhsat çizimleri, eski eser yapılarının röleve, restitüsyon ve restorasyon çizimleri, çeşitli iç mekan tasarım ve uygulamaları üzerinde hizmet vermektedir.\nFirma gençlik ve dinamizmden yola çıkarak her proje için yazdığı hikayede yeniliğe ve sürdürülebilirliğe önem vermektedir. Sizlere ihtiyaçlarınızın doğru analiz edildiği ve beğenilerinizin doğrultusunda bir mimarlık hizmeti sunmaktadır.\nGeçmişi, bugünü ve geleceği sentezleyerek geleneksel olanı güncel vizyonu ile değerlendirip mekanlara yeni kimlikler kazandırır. Kültürel mirasa sahip çıkarak tarihler boyu devamlılığını sağlar. Özellikle tarihi doku ve yapılar için röleve, restitüsyon ve restorasyon çalışmalarını içeren projeler üretir.\nBDÇ Mimarlık bünyesinde yapılan iç mekan tasarım ve uygulamalarının detaylarını inceleyebilirsiniz.\nSaygılarımızla...",
      "en": "Büşra Dindar Çöllü graduated with distinction from the faculty of architecture in 2021. Over four years spent working in active practices, she completed commissions of her own alongside that work and built on her experience. In 2025 she founded BDÇ Mimarlık, bringing her knowledge and experience together under one roof.\n\nBDÇ Mimarlık works on municipal building permit drawings, measured survey, restitution and restoration drawings for listed historic buildings, and a wide range of interior design and fit-out projects.\nDrawing on youth and energy, the studio gives weight to innovation and sustainability in the story it writes for each project. It offers an architectural service in which your needs are read correctly and the work follows your own taste.\nBy synthesising past, present and future, it reads the traditional through a contemporary vision and gives spaces new identities. It safeguards cultural heritage and carries it forward through time. It produces projects covering measured survey, restitution and restoration work, particularly for historic fabric and buildings.\nYou are welcome to look through the details of the interior design and fit-out work carried out by BDÇ Mimarlık.\nWith our respects..."
    }
  },
  "contact": {
    "address": "EGE MAH. BORSA CAD, 1300. Sk. NO:2E D:2C, 45010 Şehzadeler/Manisa",
    "mapsUrl": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x14b99d756f4a2991:0x97d51a0afc6cbb30?sa=X&ved=1t:8290&ictx=111",
    "email": "busradindarcollu@bdcmimarlik.com",
    "phoneText": "0531 269 97 44",
    "phoneNumber": "+905312699744"
  },
  "socials": [
    {
      "name": "Instagram",
      "url": "https://www.instagram.com/mimarbusradindarcollu"
    }
  ]
};

export const projects: Project[] = [
  {
    "slug": "ayni-ali",
    "order": 1,
    "showInSlider": true,
    "title": {
      "tr": "Aynı Ali",
      "en": "Aynı Ali"
    },
    "year": "",
    "location": "",
    "area": "",
    "workType": {
      "tr": "",
      "en": ""
    },
    "description": {
      "tr": "",
      "en": ""
    },
    "cover": {
      "src": "/content/ayni-ali/salon1-2000.webp",
      "srcSet": "/content/ayni-ali/salon1-800.webp 800w, /content/ayni-ali/salon1-1400.webp 1400w, /content/ayni-ali/salon1-2000.webp 2000w"
    },
    "images": [
      {
        "src": "/content/ayni-ali/salon1-2000.webp",
        "srcSet": "/content/ayni-ali/salon1-800.webp 800w, /content/ayni-ali/salon1-1400.webp 1400w, /content/ayni-ali/salon1-2000.webp 2000w"
      },
      {
        "src": "/content/ayni-ali/salon2-2000.webp",
        "srcSet": "/content/ayni-ali/salon2-800.webp 800w, /content/ayni-ali/salon2-1400.webp 1400w, /content/ayni-ali/salon2-2000.webp 2000w"
      },
      {
        "src": "/content/ayni-ali/salon3-2000.webp",
        "srcSet": "/content/ayni-ali/salon3-800.webp 800w, /content/ayni-ali/salon3-1400.webp 1400w, /content/ayni-ali/salon3-2000.webp 2000w"
      },
      {
        "src": "/content/ayni-ali/salon4-2000.webp",
        "srcSet": "/content/ayni-ali/salon4-800.webp 800w, /content/ayni-ali/salon4-1400.webp 1400w, /content/ayni-ali/salon4-2000.webp 2000w"
      }
    ]
  },
  {
    "slug": "guzelyurt",
    "order": 2,
    "showInSlider": true,
    "title": {
      "tr": "Güzelyurt",
      "en": "Güzelyurt"
    },
    "year": "",
    "location": "",
    "area": "",
    "workType": {
      "tr": "",
      "en": ""
    },
    "description": {
      "tr": "",
      "en": ""
    },
    "cover": {
      "src": "/content/guzelyurt/banyo1-2000.webp",
      "srcSet": "/content/guzelyurt/banyo1-800.webp 800w, /content/guzelyurt/banyo1-1400.webp 1400w, /content/guzelyurt/banyo1-2000.webp 2000w"
    },
    "images": [
      {
        "src": "/content/guzelyurt/banyo1-2000.webp",
        "srcSet": "/content/guzelyurt/banyo1-800.webp 800w, /content/guzelyurt/banyo1-1400.webp 1400w, /content/guzelyurt/banyo1-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/banyo2-2000.webp",
        "srcSet": "/content/guzelyurt/banyo2-800.webp 800w, /content/guzelyurt/banyo2-1400.webp 1400w, /content/guzelyurt/banyo2-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/banyo3-2000.webp",
        "srcSet": "/content/guzelyurt/banyo3-800.webp 800w, /content/guzelyurt/banyo3-1400.webp 1400w, /content/guzelyurt/banyo3-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/giyinme1-2000.webp",
        "srcSet": "/content/guzelyurt/giyinme1-800.webp 800w, /content/guzelyurt/giyinme1-1400.webp 1400w, /content/guzelyurt/giyinme1-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/giyinme2-2000.webp",
        "srcSet": "/content/guzelyurt/giyinme2-800.webp 800w, /content/guzelyurt/giyinme2-1400.webp 1400w, /content/guzelyurt/giyinme2-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/giyinme3-2000.webp",
        "srcSet": "/content/guzelyurt/giyinme3-800.webp 800w, /content/guzelyurt/giyinme3-1400.webp 1400w, /content/guzelyurt/giyinme3-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/mutfak1-2000.webp",
        "srcSet": "/content/guzelyurt/mutfak1-800.webp 800w, /content/guzelyurt/mutfak1-1400.webp 1400w, /content/guzelyurt/mutfak1-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/mutfak2-2000.webp",
        "srcSet": "/content/guzelyurt/mutfak2-800.webp 800w, /content/guzelyurt/mutfak2-1400.webp 1400w, /content/guzelyurt/mutfak2-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/mutfak3-2000.webp",
        "srcSet": "/content/guzelyurt/mutfak3-800.webp 800w, /content/guzelyurt/mutfak3-1400.webp 1400w, /content/guzelyurt/mutfak3-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/mutfak4-2000.webp",
        "srcSet": "/content/guzelyurt/mutfak4-800.webp 800w, /content/guzelyurt/mutfak4-1400.webp 1400w, /content/guzelyurt/mutfak4-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/mutfak5-2000.webp",
        "srcSet": "/content/guzelyurt/mutfak5-800.webp 800w, /content/guzelyurt/mutfak5-1400.webp 1400w, /content/guzelyurt/mutfak5-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/oturma1-2000.webp",
        "srcSet": "/content/guzelyurt/oturma1-800.webp 800w, /content/guzelyurt/oturma1-1400.webp 1400w, /content/guzelyurt/oturma1-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/oturma2-2000.webp",
        "srcSet": "/content/guzelyurt/oturma2-800.webp 800w, /content/guzelyurt/oturma2-1400.webp 1400w, /content/guzelyurt/oturma2-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/oturma3-2000.webp",
        "srcSet": "/content/guzelyurt/oturma3-800.webp 800w, /content/guzelyurt/oturma3-1400.webp 1400w, /content/guzelyurt/oturma3-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/oturma4-2000.webp",
        "srcSet": "/content/guzelyurt/oturma4-800.webp 800w, /content/guzelyurt/oturma4-1400.webp 1400w, /content/guzelyurt/oturma4-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/yatak1-2000.webp",
        "srcSet": "/content/guzelyurt/yatak1-800.webp 800w, /content/guzelyurt/yatak1-1400.webp 1400w, /content/guzelyurt/yatak1-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/yemek-2000.webp",
        "srcSet": "/content/guzelyurt/yemek-800.webp 800w, /content/guzelyurt/yemek-1400.webp 1400w, /content/guzelyurt/yemek-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/yemek1-2000.webp",
        "srcSet": "/content/guzelyurt/yemek1-800.webp 800w, /content/guzelyurt/yemek1-1400.webp 1400w, /content/guzelyurt/yemek1-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/yemek2-2000.webp",
        "srcSet": "/content/guzelyurt/yemek2-800.webp 800w, /content/guzelyurt/yemek2-1400.webp 1400w, /content/guzelyurt/yemek2-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/yemek3-2000.webp",
        "srcSet": "/content/guzelyurt/yemek3-800.webp 800w, /content/guzelyurt/yemek3-1400.webp 1400w, /content/guzelyurt/yemek3-2000.webp 2000w"
      },
      {
        "src": "/content/guzelyurt/yemek4-2000.webp",
        "srcSet": "/content/guzelyurt/yemek4-800.webp 800w, /content/guzelyurt/yemek4-1400.webp 1400w, /content/guzelyurt/yemek4-2000.webp 2000w"
      }
    ]
  },
  {
    "slug": "kecilikoy",
    "order": 3,
    "showInSlider": true,
    "title": {
      "tr": "Keçiliköy",
      "en": "Keçiliköy"
    },
    "year": "",
    "location": "",
    "area": "",
    "workType": {
      "tr": "",
      "en": ""
    },
    "description": {
      "tr": "",
      "en": ""
    },
    "cover": {
      "src": "/content/kecilikoy/oturma3-2000.webp",
      "srcSet": "/content/kecilikoy/oturma3-800.webp 800w, /content/kecilikoy/oturma3-1400.webp 1400w, /content/kecilikoy/oturma3-2000.webp 2000w"
    },
    "images": [
      {
        "src": "/content/kecilikoy/banyo-2000.webp",
        "srcSet": "/content/kecilikoy/banyo-800.webp 800w, /content/kecilikoy/banyo-1400.webp 1400w, /content/kecilikoy/banyo-2000.webp 2000w"
      },
      {
        "src": "/content/kecilikoy/ebeveyn-yatak-odasi-2000.webp",
        "srcSet": "/content/kecilikoy/ebeveyn-yatak-odasi-800.webp 800w, /content/kecilikoy/ebeveyn-yatak-odasi-1400.webp 1400w, /content/kecilikoy/ebeveyn-yatak-odasi-2000.webp 2000w"
      },
      {
        "src": "/content/kecilikoy/ebeveyn-yatak-odasi2-2000.webp",
        "srcSet": "/content/kecilikoy/ebeveyn-yatak-odasi2-800.webp 800w, /content/kecilikoy/ebeveyn-yatak-odasi2-1400.webp 1400w, /content/kecilikoy/ebeveyn-yatak-odasi2-2000.webp 2000w"
      },
      {
        "src": "/content/kecilikoy/ikinci-yatak-odasi-2000.webp",
        "srcSet": "/content/kecilikoy/ikinci-yatak-odasi-800.webp 800w, /content/kecilikoy/ikinci-yatak-odasi-1400.webp 1400w, /content/kecilikoy/ikinci-yatak-odasi-2000.webp 2000w"
      },
      {
        "src": "/content/kecilikoy/oturma1-2000.webp",
        "srcSet": "/content/kecilikoy/oturma1-800.webp 800w, /content/kecilikoy/oturma1-1400.webp 1400w, /content/kecilikoy/oturma1-2000.webp 2000w"
      },
      {
        "src": "/content/kecilikoy/oturma2-2000.webp",
        "srcSet": "/content/kecilikoy/oturma2-800.webp 800w, /content/kecilikoy/oturma2-1400.webp 1400w, /content/kecilikoy/oturma2-2000.webp 2000w"
      },
      {
        "src": "/content/kecilikoy/oturma3-2000.webp",
        "srcSet": "/content/kecilikoy/oturma3-800.webp 800w, /content/kecilikoy/oturma3-1400.webp 1400w, /content/kecilikoy/oturma3-2000.webp 2000w"
      },
      {
        "src": "/content/kecilikoy/oturma4-2000.webp",
        "srcSet": "/content/kecilikoy/oturma4-800.webp 800w, /content/kecilikoy/oturma4-1400.webp 1400w, /content/kecilikoy/oturma4-2000.webp 2000w"
      },
      {
        "src": "/content/kecilikoy/tv-2000.webp",
        "srcSet": "/content/kecilikoy/tv-800.webp 800w, /content/kecilikoy/tv-1400.webp 1400w, /content/kecilikoy/tv-2000.webp 2000w"
      }
    ]
  },
  {
    "slug": "pilates-salonu",
    "order": 4,
    "showInSlider": true,
    "title": {
      "tr": "Pilates Salonu",
      "en": "Pilates Salonu"
    },
    "year": "",
    "location": "",
    "area": "",
    "workType": {
      "tr": "",
      "en": ""
    },
    "description": {
      "tr": "",
      "en": ""
    },
    "cover": {
      "src": "/content/pilates-salonu/spor-salonu2-2000.webp",
      "srcSet": "/content/pilates-salonu/spor-salonu2-800.webp 800w, /content/pilates-salonu/spor-salonu2-1400.webp 1400w, /content/pilates-salonu/spor-salonu2-2000.webp 2000w"
    },
    "images": [
      {
        "src": "/content/pilates-salonu/spor-salonu1-2000.webp",
        "srcSet": "/content/pilates-salonu/spor-salonu1-800.webp 800w, /content/pilates-salonu/spor-salonu1-1400.webp 1400w, /content/pilates-salonu/spor-salonu1-2000.webp 2000w"
      },
      {
        "src": "/content/pilates-salonu/spor-salonu2-2000.webp",
        "srcSet": "/content/pilates-salonu/spor-salonu2-800.webp 800w, /content/pilates-salonu/spor-salonu2-1400.webp 1400w, /content/pilates-salonu/spor-salonu2-2000.webp 2000w"
      },
      {
        "src": "/content/pilates-salonu/spor-salonu3-2000.webp",
        "srcSet": "/content/pilates-salonu/spor-salonu3-800.webp 800w, /content/pilates-salonu/spor-salonu3-1400.webp 1400w, /content/pilates-salonu/spor-salonu3-2000.webp 2000w"
      },
      {
        "src": "/content/pilates-salonu/spor-salonu4-2000.webp",
        "srcSet": "/content/pilates-salonu/spor-salonu4-800.webp 800w, /content/pilates-salonu/spor-salonu4-1400.webp 1400w, /content/pilates-salonu/spor-salonu4-2000.webp 2000w"
      },
      {
        "src": "/content/pilates-salonu/spor-salonu5-2000.webp",
        "srcSet": "/content/pilates-salonu/spor-salonu5-800.webp 800w, /content/pilates-salonu/spor-salonu5-1400.webp 1400w, /content/pilates-salonu/spor-salonu5-2000.webp 2000w"
      },
      {
        "src": "/content/pilates-salonu/spor-salonu6-2000.webp",
        "srcSet": "/content/pilates-salonu/spor-salonu6-800.webp 800w, /content/pilates-salonu/spor-salonu6-1400.webp 1400w, /content/pilates-salonu/spor-salonu6-2000.webp 2000w"
      }
    ]
  },
  {
    "slug": "sakran",
    "order": 5,
    "showInSlider": true,
    "title": {
      "tr": "Şakran",
      "en": "Şakran"
    },
    "year": "",
    "location": "",
    "area": "",
    "workType": {
      "tr": "",
      "en": ""
    },
    "description": {
      "tr": "",
      "en": ""
    },
    "cover": {
      "src": "/content/sakran/sakran2-2000.webp",
      "srcSet": "/content/sakran/sakran2-800.webp 800w, /content/sakran/sakran2-1400.webp 1400w, /content/sakran/sakran2-2000.webp 2000w"
    },
    "images": [
      {
        "src": "/content/sakran/plan-2000.webp",
        "srcSet": "/content/sakran/plan-800.webp 800w, /content/sakran/plan-1400.webp 1400w, /content/sakran/plan-2000.webp 2000w"
      },
      {
        "src": "/content/sakran/sakran1-2000.webp",
        "srcSet": "/content/sakran/sakran1-800.webp 800w, /content/sakran/sakran1-1400.webp 1400w, /content/sakran/sakran1-2000.webp 2000w"
      },
      {
        "src": "/content/sakran/sakran2-2000.webp",
        "srcSet": "/content/sakran/sakran2-800.webp 800w, /content/sakran/sakran2-1400.webp 1400w, /content/sakran/sakran2-2000.webp 2000w"
      },
      {
        "src": "/content/sakran/sakran3-2000.webp",
        "srcSet": "/content/sakran/sakran3-800.webp 800w, /content/sakran/sakran3-1400.webp 1400w, /content/sakran/sakran3-2000.webp 2000w"
      },
      {
        "src": "/content/sakran/sakran4-2000.webp",
        "srcSet": "/content/sakran/sakran4-800.webp 800w, /content/sakran/sakran4-1400.webp 1400w, /content/sakran/sakran4-2000.webp 2000w"
      },
      {
        "src": "/content/sakran/sakran5-2000.webp",
        "srcSet": "/content/sakran/sakran5-800.webp 800w, /content/sakran/sakran5-1400.webp 1400w, /content/sakran/sakran5-2000.webp 2000w"
      }
    ]
  }
];
